//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file example/testing/data.proto (package example.testing.data, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file example/testing/data.proto.
 */
export const file_example_testing_data: GenFile = /*@__PURE__*/
  fileDesc("ChpleGFtcGxlL3Rlc3RpbmcvZGF0YS5wcm90bxIUZXhhbXBsZS50ZXN0aW5nLmRhdGEiLgoQVGVzdEl0ZW1NdXRhdGlvbhILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAkiIAoQVGVzdExpc3RNdXRhdGlvbhIMCgRkYXRhGAEgASgJIkgKEFRlc3RJdGVtU25hcHNob3QSNAoEa2V5cxgBIAMoCzImLmV4YW1wbGUudGVzdGluZy5kYXRhLlRlc3RJdGVtTXV0YXRpb24iGwoLVGVzdFBheWxvYWQSDAoEZGF0YRgBIAEoCWIGcHJvdG8z");

/**
 * @generated from message example.testing.data.TestItemMutation
 */
export type TestItemMutation = Message<"example.testing.data.TestItemMutation"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message example.testing.data.TestItemMutation.
 * Use `create(TestItemMutationSchema)` to create a new message.
 */
export const TestItemMutationSchema: GenMessage<TestItemMutation> = /*@__PURE__*/
  messageDesc(file_example_testing_data, 0);

/**
 * @generated from message example.testing.data.TestListMutation
 */
export type TestListMutation = Message<"example.testing.data.TestListMutation"> & {
  /**
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message example.testing.data.TestListMutation.
 * Use `create(TestListMutationSchema)` to create a new message.
 */
export const TestListMutationSchema: GenMessage<TestListMutation> = /*@__PURE__*/
  messageDesc(file_example_testing_data, 1);

/**
 * @generated from message example.testing.data.TestItemSnapshot
 */
export type TestItemSnapshot = Message<"example.testing.data.TestItemSnapshot"> & {
  /**
   * @generated from field: repeated example.testing.data.TestItemMutation keys = 1;
   */
  keys: TestItemMutation[];
};

/**
 * Describes the message example.testing.data.TestItemSnapshot.
 * Use `create(TestItemSnapshotSchema)` to create a new message.
 */
export const TestItemSnapshotSchema: GenMessage<TestItemSnapshot> = /*@__PURE__*/
  messageDesc(file_example_testing_data, 2);

/**
 * @generated from message example.testing.data.TestPayload
 */
export type TestPayload = Message<"example.testing.data.TestPayload"> & {
  /**
   * @generated from field: string data = 1;
   */
  data: string;
};

/**
 * Describes the message example.testing.data.TestPayload.
 * Use `create(TestPayloadSchema)` to create a new message.
 */
export const TestPayloadSchema: GenMessage<TestPayload> = /*@__PURE__*/
  messageDesc(file_example_testing_data, 3);

